module.exports = __webpack_public_path__ + "media/images/footerLogo-71e246c83fe08b55db6a87ccea936eac.svg";